const BLOCK_GAP = "\n\n";

// Un bloque de markdown (encabezado, tabla, `:::callout`) solo se publica como
// bloque si arranca en su propia linea y no queda pegado al texto de al lado.
function leadingGap(before) {
    if (before === "" || before.endsWith(BLOCK_GAP)) return "";
    return before.endsWith("\n") ? "\n" : BLOCK_GAP;
}

function trailingGap(after) {
    if (after === "" || after.startsWith(BLOCK_GAP)) return "";
    return after.startsWith("\n") ? "\n" : BLOCK_GAP;
}

function clamp(position, length) {
    return Math.max(0, Math.min(position, length));
}

export function insertSnippet(value, range, snippet) {
    const source = value || "";
    const start = clamp(range.start, source.length);
    const end = Math.max(start, clamp(range.end, source.length));
    const before = source.slice(0, start);
    const after = source.slice(end);
    const prefix = snippet.block ? leadingGap(before) : "";
    const suffix = snippet.block ? trailingGap(after) : "";
    const textStart = before.length + prefix.length;
    const placeholderAt = snippet.select
        ? snippet.text.indexOf(snippet.select)
        : -1;
    const selectionStart =
        placeholderAt === -1
            ? textStart + snippet.text.length
            : textStart + placeholderAt;

    return {
        value: before + prefix + snippet.text + suffix + after,
        selectionStart,
        selectionEnd:
            placeholderAt === -1
                ? selectionStart
                : selectionStart + snippet.select.length
    };
}

const SLASH_LINE = /^\/(\S*)$/;

// El menu solo aplica mientras el cursor esta al final de una linea que arranca
// con "/" y no tiene espacios: asi un "/" escrito dentro de un texto normal
// (una fecha, una URL) no abre nada.
export function readSlashQuery(value, caret) {
    const source = value || "";
    if (caret < 1 || caret > source.length) return null;

    const lineStart = source.lastIndexOf("\n", caret - 1) + 1;
    const lineBreak = source.indexOf("\n", caret);
    const lineEnd = lineBreak === -1 ? source.length : lineBreak;
    if (caret !== lineEnd) return null;

    const match = source.slice(lineStart, lineEnd).match(SLASH_LINE);
    if (!match) return null;

    return { start: lineStart, end: lineEnd, query: match[1] };
}
